export const API_URL_COMMON = process.env.REACT_APP_MAGIC_STAMP_API_BASE_URL;
